var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("keep-alive", { attrs: { exclude: "LogisticsMap" } }, [
        _vm.noLogistics == true
          ? _c("div", { staticClass: "no_logistics" }, [
              _vm._v("\n      当前订单无物流信息\n    ")
            ])
          : _c("div", { staticClass: "have_lt" }, [
              _vm.showMap == true
                ? _c("div", { staticClass: "if_box" }, [
                    _c("iframe", {
                      attrs: {
                        id: "map_iframe",
                        src: _vm.totalData.routeMapUrl,
                        width: "100%",
                        height: "800rpx",
                        frameborder: "0",
                        scrolling: "auto"
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.noMap == true ? "ltInfo_box_noMap" : "ltInfo_box"
                },
                [
                  _c("div", { staticClass: "info_title" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.expressCount > 1,
                            expression: "expressCount>1"
                          }
                        ],
                        staticClass: "multi_express",
                        on: { click: _vm.openExpressListPopup }
                      },
                      [
                        _vm._v(
                          "该订单被分成" +
                            _vm._s(_vm.expressCount) +
                            "个包裹，点击查看全部\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "express_box" }, [
                      _c("div", { staticClass: "express_Info" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.totalData.logisticsName) + ":")
                        ]),
                        _vm._v(" "),
                        _c("div", { attrs: { id: "logisticsNumber" } }, [
                          _vm._v(_vm._s(_vm.totalData.logisticsNumber))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "copyBtn",
                          on: {
                            click: function($event) {
                              return _vm.copyNumber()
                            }
                          }
                        },
                        [_vm._v("复制")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "address-box" }, [
                    _vm._v("收货地址：" + _vm._s(_vm.totalData.receiveAddress))
                  ]),
                  _vm._v(" "),
                  _c(
                    "van-steps",
                    {
                      attrs: {
                        active: 0,
                        direction: "vertical",
                        "active-icon": "checked",
                        "active-color": "#F75E32"
                      }
                    },
                    _vm._l(_vm.logisticsData, function(item, index) {
                      return _c("van-step", { key: index }, [
                        _c("div", { staticClass: "step_box" }, [
                          _c("h3", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(item.logStatus))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(item.createTime))
                          ])
                        ])
                      ])
                    }),
                    1
                  )
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          style: { height: "40%" },
          attrs: {
            overlay: true,
            "safe-area-inset-bottom": true,
            "close-icon-position": "top-right",
            position: "bottom"
          },
          model: {
            value: _vm.showExpressListPopup,
            callback: function($$v) {
              _vm.showExpressListPopup = $$v
            },
            expression: "showExpressListPopup"
          }
        },
        [
          _c("div", { staticClass: "pop_box" }, [
            _c("div", { staticClass: "pop_title" }, [
              _vm._v("该订单被分成" + _vm._s(_vm.expressCount) + "个包裹")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pop_content" },
              _vm._l(_vm.totalData.traceList, function(exItem, exIndex) {
                return _c(
                  "div",
                  {
                    key: exIndex,
                    staticClass: "ex_item",
                    on: {
                      click: function($event) {
                        return _vm.openNewExpress(exItem)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "70px",
                        height: "70px",
                        "margin-right": "10px"
                      },
                      attrs: { src: require("@/assets/bag.svg"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ex_left" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 0,
                              expression: "exItem.status == 0"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("暂无轨迹信息")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 1,
                              expression: "exItem.status == 1"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("已揽收")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 2,
                              expression: "exItem.status == 2"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("在途中")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 3,
                              expression: "exItem.status == 3"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("签收")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 4,
                              expression: "exItem.status == 4"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("问题件")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 5,
                              expression: "exItem.status == 5"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("转寄")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: exItem.status == 6,
                              expression: "exItem.status == 6"
                            }
                          ],
                          staticClass: "ex_status"
                        },
                        [_vm._v("清关")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "exl" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(exItem.logisticsName) +
                            ":" +
                            _vm._s(exItem.logisticsNumber) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exl" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(exItem.lastTrace) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("van-icon", { attrs: { name: "arrow" } })
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e171ad7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e171ad7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/webview/logisticsMapNew.vue
// module id = null
// module chunks = 